module.exports = __webpack_public_path__ + "img/2016-1.f5e1799c.jpeg";